import React from 'react';

type SearchIconProps = React.SVGProps<SVGSVGElement>;

export const SearchIcon: React.FC<SearchIconProps> = (props) => (
  <svg
    viewBox="0 0 20.414 20.414"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <circle
      cx="8"
      cy="8"
      r="8"
      transform="translate(3 3)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <line
      x1="0"
      y1="0"
      x2="4.35"
      y2="4.35"
      transform="translate(16.65 16.65)"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SearchIcon.displayName = 'SearchIcon';

export default SearchIcon;
